import { authUser } from './cookies.js';
import showModal from './showModal.js';
declare const bootstrap: any;

export default function initFeedbackForm() {
  const feedbackForm = document.getElementById('frmSendFeedback') as HTMLFormElement | null;
  if (!feedbackForm) return;

  const feedbackModal = new bootstrap.Modal(document.getElementById('SendFeedback'));
  const submitButton = document.getElementById('SendFeedback_Submit') as HTMLButtonElement;
  const emailInput = feedbackForm.querySelector('#Email') as HTMLInputElement;
  const urlPathInput = feedbackForm.querySelector('#SendFeedback_URLPath') as HTMLInputElement;
  const messageInput = document.getElementById('feedbackMessage') as HTMLInputElement;


  // Pre-fill fields
  urlPathInput.value = window.location.pathname;
  if (authUser?.UserName) {
    emailInput.value = authUser.UserName;
  }

  // Auto-open modal on homepage on the first 4 days of the month
    if (window.location.pathname === '/') {
        const today = new Date();
        const dayOfMonth = today.getDate();

        if (dayOfMonth >= 1 && dayOfMonth <= 3) {
            if (!localStorage.getItem("sentFeedback")) {
                feedbackModal.show();
            }
        }
    }


  submitButton.addEventListener('click', async (e) => {
    const ratingElement = feedbackForm.querySelector('.star-rating') as HTMLElement;
    e.preventDefault();

    // Reset error styles
    messageInput.classList.remove('border', 'border-danger');
    ratingElement.classList.remove('border', 'border-danger');

    // Validate message input
    if (!messageInput.value.trim() || messageInput.value.length < 2) {
      messageInput.classList.add('border', 'border-danger');
      ratingElement.classList.add('border', 'border-danger');
      return;
    }

    // Validate rating
    const userRating = ratingElement.getAttribute('data-rating');
    if (!userRating) {
      ratingElement.classList.add('border', 'border-danger');
      return;
    }

    // Prepare data for submission
    const formData = new FormData(feedbackForm);
    formData.append('Rating', userRating);

    try {
      const response = await fetch('/Feedback/SendFeedback', {
        method: 'POST',
        body: formData
      });

      const json = await response.json();
      feedbackModal.hide();

      if (json.success) {
        showModal('Feedback Sent!', json.message);
        localStorage.setItem("sentFeedback", "true");
      } else {
        showModal('Error', json.message);
      }

    } catch (error) {
      feedbackModal.hide();
      showModal('Error', 'An unexpected error occurred. Please try again.');
      console.error('Feedback submission failed:', error);
    }
  });
}
